export default __webpack_public_path__ + "static/media/home-photography-img-07.54a2f5b9.jpg";